
import GeoJSON from 'ol/format/GeoJSON';

export const transformer = (data, from, to) => {
	var format = new GeoJSON();
	const fullData = data.map(e => ({
		type: 'Feature',
		geometry: e,
		properties: {},
	}))

	var geoJsonStr = format.readFeatures(
		{
			type: 'FeatureCollection',
			features: fullData,
		},
		{ dataProjection: `EPSG:${from}`, featureProjection: `EPSG:${to}` }
	);

	var geoJsonStr2 = JSON.parse(format.writeFeatures(geoJsonStr));

	return geoJsonStr2.features.map(e => e.geometry)
}
